const setTestList = data => ({
    type: "SET_TESTS_LIST",
    data
});
export const mutation = {
    setTestList,
};
